import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonService } from '../services/common.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { FieldConfig } from '../dynamicform/models/field-config.interface';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from '../popup/popup.component';
import { DynamicFormComponent } from '../dynamicform/dynamic-form/dynamic-form.component';
import { UnitsEntity } from '../models/Units/UnitsEntity';
import * as appApiResources from '../../shared/globalcontants';
import { APIServiceProviderService } from '../services/APIServices/APIServiceProviderService/APIServiceProviderService';
import _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { GlobalConversionService } from '../services/GlobalMethodService/GlobalConversion-Service';
import { DecimalFormatterPipe } from '../pipes/decimal-formatter.pipe';

@Component({
    selector: 'app-no-math',
    templateUrl: './no-math.component.html',
    styleUrls: ['./no-math.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [DynamicFormComponent, DecimalFormatterPipe]
})
export class NoMathComponent implements OnInit, AfterViewInit {
  public editedItem: any;
  public config: FieldConfig[];
  public captions: any;
  public commonCaptions: any;

  public itemName = '';
  public actualQuantity = 0.00;
  public itemUnitDetails: UnitsEntity[];

  public buCode = '';
  public puCode = '';
  public tuCode = '';
  public ruCode = '';

  public buConversion = 0.00;
  public puConversion = 0.00;
  public tuConversion = 0.00;
  public ruConversion = 0.00;
  public ruPckSize = 0.00;

  public buConversionCaption = '';
  public puConversionCaption = '';
  public tuConversionCaption = '';
  public ruConversionCaption = '';

  public buConversionText = '';
  public puConversionText = '';
  public tuConversionText = '';
  public ruConversionText = '';

  public buttonDisable = true;
  public convertToUnitTypeId: number = appApiResources.UnitType.TransactionUnit;
  public unitCode = '';
  noMathFormValues: any;


  @ViewChild(DynamicFormComponent) formNoMath: DynamicFormComponent;
  showPopUp = false;
  tableId: any;

  constructor(public _CS: CommonService,
     private router: Router,
      private dialog: MatDialog,
       private apiServiceProviderService: APIServiceProviderService,
        private _eR: ElementRef, private _ts: TranslateService, public globalConversion:GlobalConversionService,
        private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    this._CS.component = this;
    this.captions = this._ts.instant('noMath');
    this.commonCaptions = this._ts.instant('common');
    this.editedItem = this._CS.editedItem;
    this.buConversionCaption = this.captions.baseUnit;
    this.puConversionCaption = this.captions.purchaseUnit;
    this.tuConversionCaption = this.captions.transactionUnit;
    this.ruConversionCaption = this.captions.recipeUnit;

    this.tableId = this.activatedRoute.snapshot.queryParams['from'] || null;
    const deviceType = window.localStorage.getItem('deviceType');
    if (this.editedItem) {
      this.itemName = this.editedItem.itemName;
      this.actualQuantity = this.editedItem.quantity ? 
      this.editedItem.quantity : this.globalConversion.customformatter(0);

      if (this.editedItem && this.editedItem.itemUnitDetails && this.editedItem.itemUnitDetails.length > 0) {
        this.itemUnitDetails = this.editedItem.itemUnitDetails;

        if (this.itemUnitDetails && this.itemUnitDetails.length > 0) {

          this.buCode = this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.BaseUnit)
            && this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.BaseUnit).UnitCode
            ? this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.BaseUnit).UnitCode : '';
          this.puCode = this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.PurchaseUnit)
            && this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.PurchaseUnit).UnitCode
             ? this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.PurchaseUnit).UnitCode : '';
          this.tuCode = this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.TransactionUnit)
            && this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.TransactionUnit).UnitCode
             ? this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.TransactionUnit).UnitCode : '';
          this.ruCode = this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.RecipeUnit)
            && this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.RecipeUnit).UnitCode
             ? this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.RecipeUnit).UnitCode : '';

          this.buConversion = this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.BaseUnit)
            && this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.BaseUnit).Conversion
             ? this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.BaseUnit).Conversion : 0.00;
          this.puConversion = this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.PurchaseUnit)
            && this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.PurchaseUnit).Conversion
             ? this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.PurchaseUnit).Conversion : 0.00;
          this.tuConversion = this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.TransactionUnit)
            && this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.TransactionUnit).Conversion
             ? this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.TransactionUnit).Conversion : 0.00;
          this.ruConversion = this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.RecipeUnit)
            && this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.RecipeUnit).Conversion
             ? this.itemUnitDetails.find(i => i.UnitTypeId === appApiResources.UnitType.RecipeUnit).Conversion : 0.00;

          if (this.ruConversion && this.ruConversion !== 0) {
            this.ruPckSize = this.ruConversion;
          } else {
            this.ruPckSize = this.ruConversion;
          }

          this.buConversionCaption = this.buCode === '' ? this.buConversionCaption : `${this.buConversionCaption} (${this.buCode})`;
          this.puConversionCaption = this.puCode === '' ? this.puConversionCaption : `${this.puConversionCaption} (${this.puCode})`;
          this.tuConversionCaption = this.tuCode === '' ? this.tuConversionCaption : `${this.tuConversionCaption} (${this.tuCode})`;
          this.ruConversionCaption = this.ruCode === '' ? this.ruConversionCaption : `${this.ruConversionCaption} (${this.ruCode})`;

          this.buConversionText = `1${this.buCode} = ${this.globalConversion.customformatter(this.buConversion)}`;
          this.puConversionText = `1${this.puCode} = ${this.globalConversion.customformatter(this.puConversion)} ${this.buCode}`;
          this.tuConversionText = `1${this.tuCode} = ${this.globalConversion.customformatter(this.tuConversion)} ${this.buCode}`;
          this.ruConversionText = `1${this.ruCode} = ${this.globalConversion.customformatter(this.ruPckSize)} ${this.buCode}`;

          this.unitCode = this.tuCode;
          if (this.editedItem.convertToUnitTypeId) {
            this.convertToUnitTypeId = this.editedItem.convertToUnitTypeId;

            switch (this.convertToUnitTypeId) {
              case appApiResources.UnitType.BaseUnit:
                this.unitCode = this.buCode;
                break;
              case appApiResources.UnitType.PurchaseUnit:
                this.unitCode = this.puCode;
                break;
              case appApiResources.UnitType.TransactionUnit:
                this.unitCode = this.tuCode;
                break;
              case appApiResources.UnitType.RecipeUnit:
                this.unitCode = this.ruCode;
                break;
            }
          }
        }
      }
    }

    this._CS.titleOptions = {
      'back': true,
      'pageTitle': this.itemName,
      'backFunction': this.backClick
    };


   if(this._CS.IsRguest && this.editedItem.divisionId==2)
     {
   this.config = [
      {
        type: 'input',
        label: this.buConversionCaption,
        name: 'base',
        placeholder: this.buConversionCaption,
        inputType: deviceType === 'iOS' ? 'text': this._CS.inputType,
        hint: true,
        hintRight: true,
        hintText: this.buConversionText,
        directive: 'numberOnly',
        inputClassName: 'baseField',
        fieldFormatter: 'decimal',
        isNegativeNumberAllowed: (this.tableId === 'newPhysicalInventory') ? false : true
      },          
      {
        type: 'button',
        label: this.commonCaptions.confirm,
        name: 'Submitbutton',
        class: 'large-button-mobile-confirm confirm-button',
        disabled: this.buttonDisable
      },
      {
        type: 'reset',
        label: this.commonCaptions.cancel,
        name: 'reset',
        class: 'large-button-mobile-cancel cancel-button',
        function: this.cancel.bind(this)
      }
    ];
  }
  else if( this.editedItem.divisionId==2)
  {
    this.config = [
      {
        type: 'input',
        label: this.buConversionCaption,
        name: 'base',
        placeholder: this.buConversionCaption,
        inputType: deviceType === 'iOS' ? 'text': this._CS.inputType,
        hint: true,
        hintRight: true,
        hintText: this.buConversionText,
        directive: 'numberOnly',
        inputClassName: 'baseField',
        fieldFormatter: 'decimal',
        isNegativeNumberAllowed: (this.tableId === 'newPhysicalInventory') ? false : true
      },
      {
        type: 'input',
        label: this.puConversionCaption,
        name: 'purchase',
        placeholder: this.puConversionCaption,
        hint: true,
        hintRight: true,
        hintText: this.puConversionText,
        directive: 'numberOnly',
        inputType: deviceType === 'iOS' ? 'text': this._CS.inputType,
        inputClassName: 'puField',
        fieldFormatter: 'decimal',
        isNegativeNumberAllowed: (this.tableId === 'newPhysicalInventory') ? false : true
      },            
      {
        type: 'button',
        label: this.commonCaptions.confirm,
        name: 'Submitbutton',
        class: 'large-button-mobile-confirm confirm-button',
        disabled: this.buttonDisable
      },
      {
        type: 'reset',
        label: this.commonCaptions.cancel,
        name: 'reset',
        class: 'large-button-mobile-cancel cancel-button',
        function: this.cancel.bind(this)
      }
    ];
  }
  else
  {
    this.config = [
      {
        type: 'input',
        label: this.buConversionCaption,
        name: 'base',
        placeholder: this.buConversionCaption,
        inputType: deviceType === 'iOS' ? 'text': this._CS.inputType,
        hint: true,
        hintRight: true,
        hintText: this.buConversionText,
        directive: 'numberOnly',
        inputClassName: 'baseField',
        fieldFormatter: 'decimal',
        isNegativeNumberAllowed: (this.tableId === 'newPhysicalInventory') ? false : true
      },
      {
        type: 'input',
        label: this.puConversionCaption,
        name: 'purchase',
        placeholder: this.puConversionCaption,
        hint: true,
        hintRight: true,
        hintText: this.puConversionText,
        directive: 'numberOnly',
        inputType: deviceType === 'iOS' ? 'text': this._CS.inputType,
        inputClassName: 'puField',
        fieldFormatter: 'decimal',
        isNegativeNumberAllowed: (this.tableId === 'newPhysicalInventory') ? false : true
      },
      {
        type: 'input',
        label: this.tuConversionCaption,
        name: 'transaction',
        placeholder: this.tuConversionCaption,
        
        hint: true,
        hintRight: true,
        hintText: this.tuConversionText,
        directive: 'numberOnly',
        inputType: deviceType === 'iOS' ? 'text': this._CS.inputType,
        inputClassName: 'tuField',
        fieldFormatter: 'decimal',
        isNegativeNumberAllowed: (this.tableId === 'newPhysicalInventory') ? false : true
      },
      {
        type: 'input',
        label: this.ruConversionCaption,
        name: 'recipe',
        placeholder: this.ruConversionCaption,
        hint: true,
        hintRight: true,
        hintText: this.ruConversionText,
        directive: 'numberOnly',
        inputType: deviceType === 'iOS' ? 'text': this._CS.inputType,
        inputClassName: 'ruField',
        fieldFormatter: 'decimal',
        isNegativeNumberAllowed: (this.tableId === 'newPhysicalInventory') ? false : true
      },
      {
        type: 'button',
        label: this.commonCaptions.confirm,
        name: 'Submitbutton',
        class: 'large-button-mobile-confirm confirm-button',
        disabled: this.buttonDisable
      },
      {
        type: 'reset',
        label: this.commonCaptions.cancel,
        name: 'reset',
        class: 'large-button-mobile-cancel cancel-button',
        function: this.cancel.bind(this)
      }
    ];
  }
  }

  backClick(event, _this) {
    const formTouched = _this.formNoMath.form.touched;
    const formDirty = _this.formNoMath.form.dirty;
    const isFormValid  = (_this.formNoMath.form.value.base !== '' && _this.formNoMath.form.value.base !== undefined) ||
              (_this.formNoMath.form.value.purchase !== '' && _this.formNoMath.form.value.purchase !== undefined) ||
              (_this.formNoMath.form.value.recipe !== '' && _this.formNoMath.form.value.recipe !== undefined) ||
              (_this.formNoMath.form.value.reset !== '' && _this.formNoMath.form.value.reset !== undefined) ||
              (_this.formNoMath.form.value.transaction !== '' && _this.formNoMath.form.value.transaction !== undefined);
    if (formTouched) {
      if (formDirty && isFormValid) {
        _this.confirmBack();
      } else {
        _this.navigateBack();
      }
    } else {
      _this.navigateBack();
    }
    _this._CS.addQuantity = false;
  }

  confirmBack() {
    const dialogArray = { headerText: this._ts.instant('noMath.revertChanges'),
     contentText: this._ts.instant('noMath.cancelConfirmation'),
      cancelText: this._ts.instant('common.cancel'), confirmText: this._ts.instant('common.confirm'),
        confirmHelpText: 'CONFIRM',
        cancelHelpText: 'CANCEL' };

    this._CS.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent,
      this._CS.mobilePopUpProperty
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        switch (result) {
          case 'CONFIRM': this.navigateBack(); break;
        }

      }
    });
  }

  navigateBack() {
    this._CS.noMathBack = true;
    const pop = this._CS.routeStack.pop();
    if (pop.split('?').length > 1) {
      const url = this._CS.generateParams(pop);
      url.queryParams.routedFrom = 'fromNoMath';
      this.router.navigate([pop.split('?')[0]], url);
    } else {
      const params = {};
      const navigationExtras: NavigationExtras = {
        queryParams: params
      };
      navigationExtras.queryParams.routedFrom = 'fromNoMath';
      this.router.navigate([pop], navigationExtras);
    }
  }

  cancel(_this) {
    _this.preventDefault();
    this._CS.addQuantity = false;
    this._CS.fromNoMath = true;
    if (this.showPopUp) {
      this.confirmBack();
    } else {
      this.navigateBack();
    }
  }
  mathonChange(event: any) {
     if (event.target.value !== '' && event.target.name !== '') {
      const value: number = event.target.value;
      this.formNoMath.setValue(event.target.name, (isNaN(value) ? '' :
      this.apiServiceProviderService.utilityService.DecimalFormatter.format(parseFloat(value.toString().split(',').join('')))));
    }
  }

  confirm(event) {
    this.noMathFormValues = event;
    let calculatedQty = 0.00;
    calculatedQty = this.calculateQty(this.convertToUnitTypeId);
    if (this.editedItem?.BatchId && this.editedItem?.PurchaseQTY && calculatedQty > this.editedItem?.PurchaseQTY) {
      this.actualQuantity -= calculatedQty;
      const dialogArray = { headerText: this._ts.instant('common.Info'),
      contentText: this._ts.instant('physicalInventory.BatchQtyMsg'),
      cancelText: null, confirmText: this._ts.instant('common.ok')};
      this._CS.mobilePopUpProperty.data = dialogArray;
      this.dialog.open(PopupComponent,
        this._CS.mobilePopUpProperty
      );
      return;
    }
    this._CS.updatedQuantity = calculatedQty;
    this._CS.addQuantity = true; 
    this.navigateBack();
    let existingHistory = [];
    this._CS.noMathHistory.subscribe(value => {
      existingHistory = value;
    });


    const lists = {
      'initialQty': `${this.editedItem.quantity ? this.globalConversion.customformatter(parseFloat(this.editedItem.quantity)) : 
        this.globalConversion.customformatter(0)} ${this.unitCode}`,
      'endQty': `${this.globalConversion.customformatter(calculatedQty)} ${this.unitCode}`,
      'details': []
    };
    const history = [];
    for (const key in event) {

      if (event[key] && !isNaN(Number(event[key].toString().split(',').join('')))) {
        let unit = '';

        switch (key) {
          case 'base':
            unit = this.buCode;
            break;
          case 'recipe':
            unit = this.ruCode;
            break;
          case 'transaction':
            unit = this.tuCode;
            break;
          case 'purchase':
            unit = this.puCode;
            break;
        }
        const countValue = (event[key] !== '' && event[key] !== undefined) ? Number(event[key].toString().split(',').join('')) : null;
        if (countValue != null) {
          const unitValue = { 'count': countValue, 'unit': unit, 'unitName': `${key} ${this._ts.instant('common.unit')}` };
          history.push(unitValue);
        }

      }

    }
    lists.details = history;
    if (existingHistory && existingHistory.length > 0) {
      existingHistory.push(lists);
    } else {
      existingHistory = [];
      existingHistory[0] = lists;
    }
    this._CS.noMathHistory.next(existingHistory);
    this._CS.addQuantity = true;
  }

  ngAfterViewInit(): void {
    this.formNoMath.form.get('base').valueChanges.subscribe(x => {
      setTimeout(() => {
        this.checkValues();
      }, 1);
    });
    this.formNoMath.form.get('purchase') ? this.formNoMath.form.get('purchase').valueChanges.subscribe(x => {
      setTimeout(() => {
        this.checkValues();
      }, 1);            
    }) : '';
    this.formNoMath.form.get('transaction') ? this.formNoMath.form.get('transaction').valueChanges.subscribe(x => {
      setTimeout(() => {
        this.checkValues();
      }, 1);
    }) : '';
    this.formNoMath.form.get('recipe') ? this.formNoMath.form.get('recipe').valueChanges.subscribe(x => {
      setTimeout(() => {
        this.checkValues();
      }, 1);
    }) : '';

    this.formNoMath.form.valueChanges.subscribe(x => {
      const noMathForm = this.formNoMath.form.value;
      if ((noMathForm.base !== '' && noMathForm.base !== undefined ) ||
      (noMathForm.recipe !== '' && noMathForm.recipe !== undefined  ) ||
      (noMathForm.transaction !== '' && noMathForm.transaction !== undefined ) ||
      (noMathForm.purchase !== '' && noMathForm.purchase !== undefined )) {
        this.showPopUp = true;
      } else {
        this.showPopUp = false;
      }
    });
  }

  checkValues() {
    // baseField puField tuField ruField;
    const baseValue = this._eR.nativeElement.getElementsByClassName('baseField').length>0 ? 
    this._eR.nativeElement.getElementsByClassName('baseField')[0].value : ''; // this.formNoMath.form.get('base').value;
    const recipeValue =   this._eR.nativeElement.getElementsByClassName('ruField').length>0 ? 
    this._eR.nativeElement.getElementsByClassName('ruField')[0].value : '';  
    const transactionValue = this._eR.nativeElement.getElementsByClassName('tuField').length>0 ?
     this._eR.nativeElement.getElementsByClassName('tuField')[0].value : '';
    const purchaseValue = this._eR.nativeElement.getElementsByClassName('puField').length>0 ?
    this._eR.nativeElement.getElementsByClassName('puField')[0].value : ''; // this.formNoMath.form.get('purchase').value; // this.formNoMath.form.get('recipe').value;

    const baseValueCheck = parseFloat(this.apiServiceProviderService.utilityService.DecimalFormatter.
      format(Number(baseValue.toString().split(',').join(''))));
    const recipeValueCheck = parseFloat(this.apiServiceProviderService.utilityService.DecimalFormatter.
      format(Number(recipeValue.toString().split(',').join(''))));
    const transactionValueCheck = parseFloat(this.apiServiceProviderService.utilityService.DecimalFormatter.
                                  format(Number(transactionValue.toString().split(',').join(''))));
    const purchaseValueCheck = parseFloat(this.apiServiceProviderService.utilityService.DecimalFormatter.
      format(Number(purchaseValue.toString().split(',').join(''))));

    if (
      (baseValue !== '' && baseValue !== undefined && !isNaN(baseValueCheck)) ||
      (recipeValue !== '' && recipeValue !== undefined && !isNaN(recipeValueCheck) ) ||
      (transactionValue !== '' && transactionValue !== undefined && !isNaN(transactionValueCheck) ) ||
      (purchaseValue !== '' && purchaseValue !== undefined && !isNaN(purchaseValueCheck) )
    ) {
      this.formNoMath.config.find(x => x.type === 'button').disabled = false;
    } else {
      this.formNoMath.config.find(x => x.type === 'button').disabled = true;
    }
  }

  calculateQty(toUnitTypeId: number): number {
    let calculatedQty = 0.00;
    let buQty = 0.00;
    let puQty = 0.00;
    let tuQty = 0.00;
    let ruQty = 0.00;
    let buPcakSize = 0.00;
    let puPcakSize = 0.00;
    let tuPcakSize = 0.00;
    let ruPcakSize = 0.00;
    let buQtyFrmBUQty = 0.00;
    let buQtyFrmPUQty = 0.00;
    let buQtyFrmTUQty = 0.00;
    let buQtyFrmRUQty = 0.00;
    try {
      buQty = this.noMathFormValues['base'] ? this.noMathFormValues['base'] : 0;
      puQty = this.noMathFormValues['purchase'] ? this.noMathFormValues['purchase'] : 0;
      tuQty = this.noMathFormValues['transaction'] ? this.noMathFormValues['transaction'] : 0;
      ruQty = this.noMathFormValues['recipe'] ? this.noMathFormValues['recipe'] : 0;

      buQty = Number(buQty.toString().split(',').join(''));
      puQty = Number(puQty.toString().split(',').join(''));
      tuQty = Number(tuQty.toString().split(',').join(''));
      ruQty = Number(ruQty.toString().split(',').join(''));
      // 2. Find Pack Size.
      buPcakSize = 1 * this.buConversion;
      puPcakSize = 1 * this.puConversion;
      tuPcakSize = 1 * this.tuConversion;
      if (this.ruConversion !== 0) {
         ruPcakSize= this.ruConversion;
      }
      // 3. Convert All Qty to BaseUnit Qty
      buQtyFrmBUQty = (buPcakSize ? buPcakSize : 0.00) * (buQty ? buQty : 0.00);
      buQtyFrmPUQty = (puPcakSize ? puPcakSize : 0.00) * (puQty ? puQty : 0.00);
      buQtyFrmTUQty = (tuPcakSize ? tuPcakSize : 0.00) * (tuQty ? tuQty : 0.00);
      buQtyFrmRUQty = (ruPcakSize ? ruPcakSize : 0.00) * (ruQty ? ruQty : 0.00);
      // 4. Convert All BaseUnit Qty To Corresponding Unit Qty
      switch (toUnitTypeId) {
        case appApiResources.UnitType.BaseUnit:
          calculatedQty = buQtyFrmBUQty + buQtyFrmPUQty + buQtyFrmTUQty + buQtyFrmRUQty;
          break;
        case appApiResources.UnitType.PurchaseUnit:
          let puQtyfromBUQty = 0.00;
          let puQtyfromPUQty = 0.00;
          let puQtyfromTUQty = 0.00;
          let puQtyfromRUQty = 0.00;
          if (buQtyFrmBUQty !== 0 && puPcakSize !== 0) {
            puQtyfromBUQty = buQtyFrmBUQty / puPcakSize;
          }
          if (buQtyFrmPUQty !== 0 && puPcakSize !== 0) {
            puQtyfromPUQty = buQtyFrmPUQty / puPcakSize;
          }
          if (buQtyFrmTUQty !== 0 && puPcakSize !== 0) {
            puQtyfromTUQty = buQtyFrmTUQty / puPcakSize;
          }
          if (buQtyFrmRUQty !== 0 && puPcakSize !== 0) {
            puQtyfromRUQty = buQtyFrmRUQty / puPcakSize;
          }
          calculatedQty = puQtyfromBUQty + puQtyfromPUQty + puQtyfromTUQty + puQtyfromRUQty;
          break;

        // Convert All BaseUnit Qty To TransactionUnit Qty and add
        case appApiResources.UnitType.TransactionUnit:

          let tuQtyfromBUQty = 0.00;
          let tuQtyfromPUQty = 0.00;
          let tuQtyfromTUQty = 0.00;
          let tuQtyfromRUQty = 0.00;

          if (buQtyFrmBUQty !== 0 && tuPcakSize !== 0) {
            tuQtyfromBUQty = buQtyFrmBUQty / tuPcakSize;
          }

          if (buQtyFrmPUQty !== 0 && tuPcakSize !== 0) {
            tuQtyfromPUQty = buQtyFrmPUQty / tuPcakSize;
          }

          if (buQtyFrmTUQty !== 0 && tuPcakSize !== 0) {
            tuQtyfromTUQty = buQtyFrmTUQty / tuPcakSize;
          }

          if (buQtyFrmRUQty !== 0 && tuPcakSize !== 0) {
            tuQtyfromRUQty = buQtyFrmRUQty / tuPcakSize;
          }

          calculatedQty = tuQtyfromBUQty + tuQtyfromPUQty + tuQtyfromTUQty + tuQtyfromRUQty;

          break;

        case appApiResources.UnitType.RecipeUnit:
          let ruQtyfromBUQty = 0.00;
          let ruQtyfromPUQty = 0.00;
          let ruQtyfromTUQty = 0.00;
          let ruQtyfromRUQty = 0.00;

          if (buQtyFrmBUQty !== 0 && ruPcakSize !== 0) {
            ruQtyfromBUQty = buQtyFrmBUQty / ruPcakSize;
          }

          if (buQtyFrmPUQty !== 0 && ruPcakSize !== 0) {
            ruQtyfromPUQty = buQtyFrmPUQty / ruPcakSize;
          }

          if (buQtyFrmTUQty !== 0 && ruPcakSize !== 0) {
            ruQtyfromTUQty = buQtyFrmTUQty / ruPcakSize;
          }

          if (buQtyFrmRUQty !== 0 && ruPcakSize !== 0) {
            ruQtyfromRUQty = buQtyFrmRUQty / ruPcakSize;
          }

          calculatedQty = ruQtyfromBUQty + ruQtyfromPUQty + ruQtyfromTUQty + ruQtyfromRUQty;
          break;
      }

      this.actualQuantity = parseFloat(this.actualQuantity.toString()) + calculatedQty;
    } catch (e) {
      calculatedQty = 0.00;
    }
    const decimalPoint = this._CS.decimalFocusinLength;
    return calculatedQty = parseFloat(this.actualQuantity.toFixed(decimalPoint));
  }

}
